export interface Dict<T = string> {
    [id: string]: T;
}

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export type Properties<Names extends string, Value = {}> = {[P in Names]: Value};

export type ProperyGetter<Type, Property extends keyof Type> = (value: Type) => Type[Property];

export type AsyncFunction<T = void> = () => Promise<T>;

export function notNull<T>(value: T | null): value is T {
    return value != null;
}

export function isHTMLElement(value: unknown): value is HTMLElement {
    return value != null && (value as HTMLElement).getBoundingClientRect != null;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/Types.ts